import React from 'react';
import { LinkedinIcon, YoutubeIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer data-id="element-100">
      {/* Main Footer — Contact */}
      <div className="bg-navy-dark pt-14 pb-12" data-id="element-101">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12" data-id="element-102">
          <div className="w-full h-[1px] bg-gold/20 mb-10" data-id="element-103" />

          <div className="flex flex-col md:flex-row justify-between gap-10" data-id="element-104">
            {/* Brand */}
            <div className="flex flex-col items-center md:items-start gap-2" data-id="element-105">
              <div className="font-heading font-bold text-2xl text-white tracking-tight" data-id="element-106">
                Schaller Coaching
              </div>
              <span className="font-heading text-[11px] text-gold/70 uppercase tracking-[0.1em]" data-id="element-107">
                Leadership Coaching & Development
              </span>
            </div>

            {/* Contact Info */}
            <div className="flex flex-col items-center md:items-end gap-3 text-center md:text-right" data-id="element-108">
              <span className="font-heading font-semibold text-[15px] text-white" data-id="element-109">
                Contact Schaller International LLC
              </span>
              <p className="text-[13px] text-warm-light/60 max-w-[340px] leading-relaxed" data-id="element-110">
                We are here to answer any questions you might have. We look
                forward to hearing from you.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mt-1" data-id="element-111">
                <a href="mailto:greg@schallerinternational.com" className="inline-flex items-center gap-2 text-[13px] text-warm-light/80 hover:text-gold transition-colors duration-300" data-id="element-112">
                  <MailIcon size={14} strokeWidth={1.5} data-id="element-113" />
                  greg@schallerinternational.com
                </a>
                <a href="tel:+12535696623" className="inline-flex items-center gap-2 text-[13px] text-warm-light/80 hover:text-gold transition-colors duration-300" data-id="element-114">
                  <PhoneIcon size={14} strokeWidth={1.5} data-id="element-115" />
                  +1 253.569.6623
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GDPR / Legal Bar with Social Icons */}
      <div className="bg-[#0F2035] py-4" data-id="element-116">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12" data-id="element-117">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-118">
            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-5 text-[12px] text-warm-light/40" data-id="element-119">
              <a href="#" className="hover:text-gold transition-colors duration-300" data-id="element-120">
                Terms & Conditions
              </a>
              <a href="#" className="hover:text-gold transition-colors duration-300" data-id="element-121">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-gold transition-colors duration-300" data-id="element-122">
                Cookie Policy
              </a>
              <span data-id="element-123">
                © 2026 Schaller International LLC. All rights reserved.
              </span>
            </div>

            {/* Social Icons */}
            <div className="flex gap-3" data-id="element-124">
              <a href="https://www.linkedin.com/in/ACoAAE3Yf-kB1gZJN7iZSpbAusRmDH7w9XNjrEI" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-warm-light/50 hover:text-gold hover:border-gold/40 transition-all duration-300" data-id="element-125">
                <LinkedinIcon size={14} strokeWidth={1.5} data-id="element-126" />
              </a>
              <a href="https://www.youtube.com/@drgregschaller" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center text-warm-light/50 hover:text-gold hover:border-gold/40 transition-all duration-300" data-id="element-127">
                <YoutubeIcon size={14} strokeWidth={1.5} data-id="element-128" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}